<div class="container">
  <hcc-image
    *ngIf="imageIsVisible"
    [entry]="image"
    [imageName]="entry.fields.pageTitle"
    [preloaded]="true"
  ></hcc-image>
  <ng-container #container></ng-container>
</div>
<app-responsive-modal #welcomeMessageModal>
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    *ngIf="user$ | async as user"
  >
    <div class="overline mb-3">{{ 'common.firstLoginHeading' | cxTranslate }}</div>
    <div class="text-center mb-md-7 mb-0">
      <h2 data-qa="text-welcome-message">
        <span>{{ 'common.firstLoginGreeting' | cxTranslate }}</span>
        <span>{{ 'HABA, ' }}</span
        ><span class="underline-green-secondary">{{ user?.firstName }}!</span>
      </h2>
    </div>
  </div>
</app-responsive-modal>
